import {MoreMenu} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {MoreMenuProps} from '@sollapay/ui/components';
import type {FC} from 'react';

export type BeneficiaryMenuAction = 'edit' | 'delete';

export interface BeneficiaryMoreMenuProps {
  actions: BeneficiaryMenuAction[];
  onEdit?: () => void;
  onDelete?: () => void;
}

/** 3-dot menu for parties added via the הוסף צד inline-row flow (supplier/trustee). */
export const BeneficiaryMoreMenu: FC<BeneficiaryMoreMenuProps> = ({actions, onEdit, onDelete}) => {
  const {t} = useTranslation('trustAccounts');

  const actionConfig: Record<BeneficiaryMenuAction, MoreMenuProps['items'][number]> = {
    edit: {
      icon: 'pen',
      label: t('view.beneficiaries.tableActions.edit'),
      onClick: () => onEdit?.()
    },
    delete: {
      icon: 'delete',
      label: t('view.beneficiaries.tableActions.delete'),
      onClick: () => onDelete?.(),
      destructive: true,
      separator: true
    }
  };

  const handlerMap: Record<BeneficiaryMenuAction, (() => void) | undefined> = {
    edit: onEdit,
    delete: onDelete
  };

  const items = actions.filter(action => !!handlerMap[action]).map(action => actionConfig[action]);

  return <MoreMenu ariaLabel={t('view.beneficiaries.tableActions.moreMenu')} items={items} />;
};
